import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

const useStyles = makeStyles(() => ({
  avatarRadar: {
    position: "absolute",
    width: "100%",
    height: "100%",
    left: "0",
    top: "0",
    transform: "scale(3)",
  },
}));

export default useStyles;
